import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { HOME_ROUTE } from '../../../../constants/routes';

const ProtectedRoute = ({
  component: Comp,
  exact,
  isLoggedIn,
  verified,
  path,
}) => {
  if (verified) console.log(verified);
  return (
    <Route
      exact={exact}
      path={path}
      render={props => {
        if (isLoggedIn) {
          return <Comp {...props} />;
        }
        return <Redirect to={{ pathname: HOME_ROUTE }} />;
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.element.isRequired,
  exact: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  verified: PropTypes.bool,
  path: PropTypes.string,
};

ProtectedRoute.defaultProps = {
  isLoggedIn: false,
  exact: false,
  verified: false,
  path: '',
};

export default ProtectedRoute;
